import { Controller } from "@hotwired/stimulus"

// Submit a form for a generated PDF URL. Endpoints and paper settings stay in Rails.
export default class extends Controller {
  static targets = ["submit", "status", "panel", "summary", "frame", "link"]

  connect() {
    this.revision = 0
    this.generated = false
    this.loading = false
    this.clearPreview()
  }

  disconnect() {
    this.revision += 1
    this.request?.abort()
  }

  changed() {
    this.revision += 1
    this.clearPreview()
    if (this.generated || this.loading) {
      this.statusTarget.textContent = "設定が変更されています。プレビューを更新してください。"
      this.submitTarget.value = "プレビュー更新"
    }
  }

  clearPreview() {
    this.panelTarget.hidden = true
    this.frameTarget.removeAttribute("src")
    this.linkTarget.removeAttribute("href")
    this.linkTarget.setAttribute("aria-disabled", "true")
  }

  async submit(event) {
    event.preventDefault()
    if (this.loading || !this.element.reportValidity()) return
    this.clearPreview()
    this.loading = true
    this.submitTarget.disabled = true
    this.element.setAttribute("aria-busy", "true")
    this.statusTarget.textContent = "プレビューを作成しています…"
    this.request = new AbortController()
    const revision = this.revision

    try {
      const response = await fetch(this.element.action, {
        method: "POST", body: new FormData(this.element), credentials: "same-origin",
        headers: { Accept: "application/json", "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || "" },
        signal: this.request.signal
      })
      if (!response.headers.get("content-type")?.includes("application/json")) {
        throw new Error("プレビューを取得できませんでした。ログイン状態を確認し、画面を再読み込みしてください。")
      }
      const result = await response.json()
      if (!response.ok) throw new Error(result.error || "プレビューの作成に失敗しました。")
      if (revision !== this.revision) return
      const url = new URL(result.pdf_url, window.location.href)
      if (url.origin !== window.location.origin) throw new Error("PDFのURLを確認できませんでした。")
      this.frameTarget.src = url.href
      this.linkTarget.href = url.href
      this.linkTarget.removeAttribute("aria-disabled")
      this.summaryTarget.textContent = `${result.selection_count}件・シール合計${result.label_count}枚 ／ ${result.template_name}`
      this.panelTarget.hidden = false
      this.generated = true
      this.submitTarget.value = "プレビュー更新"
      this.statusTarget.textContent = "プレビューを作成しました。内容を確認して印刷してください。"
    } catch (error) {
      if (error.name !== "AbortError" && revision === this.revision) {
        this.statusTarget.textContent = error.message || "通信に失敗しました。もう一度お試しください。"
      }
    } finally {
      this.loading = false
      this.submitTarget.disabled = false
      this.element.removeAttribute("aria-busy")
    }
  }
}
